<template>
  <div
    class="common-hero"
    :class="hasClass"
    :style="isCover ? getBackgroundCss : ''">
    <div class="common-hero-container">
      <img
        v-if="!isCover"
        :src="bgImage"
        class="common-hero__background-image">
      <div
        v-animate-on-intersection
        class="default-container common-hero__container">
        <slot />
      </div>
    </div>
    <div
      v-if="scroll === true"
      class="home-scroll-invite"
      @click="$_scrollBottom">
      <span>{{ $t('scorri') }}</span>
      <div class="v-line"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    background: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: String,
      default: 'img'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    hasClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'viewport'
    ]),
    bgImage: {
      get () {
        if (!this.background || Object.keys(this.background).length === 0) return ''
        return `${this.background[this.viewport.label]}`
      }
    },
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    isCover: {
      get () {
        return this.tag === 'div'
      }
    },
    getBackgroundCss: {
      get () {
        if (!this.background || Object.keys(this.background).length === 0) return ''
        return `background-color: #EFEFEC; background-image: url('${this.bgImage}'); background-position: bottom center; background-size: cover;`
      }
    }
  },
  methods: {
    $_scrollBottom () {
      window.scroll({ top: this.$el.offsetHeight, left: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";
  .common-hero{
    background-size: cover;
    min-height: 100vh;
    .common-hero-container{
      width: 100%;
    }
  }
  .common-hero, .video-header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: bottom center;

    h1, h1.internal-title, h2.internal-title{
      &.hero-bigger-title{
        @include hero-bigger-title(#FFF);
      }
      @include hero-title(#FFF);
      &.font-black{
        @include hero-title(#343434);
      }
      margin-bottom: 3.5rem;
      @media #{$medium_mq} {
        margin-bottom: 4rem;
      }
      @media #{$large_mq} {
        margin-bottom: 5rem;
      }
      @media #{$xlarge_mq} {
        margin-bottom: 6rem;
      }

      br{
        display: none;
        @media #{$large_mq} {
          display: block;
        }
      }
    }

    h2.internal-title{
      max-width: 100% !important;
    }

    h2{
      font-size: 1.2rem;
      line-height: 1.6;
      color: #FFF;
      font-weight: 300;
      margin-bottom: 3rem;

      @media #{$medium_mq} {
        max-width: 85%;
        font-size: 1.35rem;
      }

      @media #{$large_mq} {
        font-size: 1.45rem;
        margin-bottom: 4rem;
        max-width: 600px;
        line-height: 1.8;
      }
      @media #{$xlarge_mq} {
        font-size: 1.65rem;
        margin-bottom: 5rem;
        max-width: 680px;
      }
      @media #{$xlarge_mq} {
        font-size: 1.875rem;
        margin-bottom: 5rem;
        max-width: 750px;
      }
    }

    p{
      @include hero-small-p(#FFF);
      &.font-black{
        @include hero-small-p(#343434);
      }
      br {
        display: none;
        @media #{$large_mq} {
          display: block;
        }
      }
    }

    .common-hero__page-content, .common-hero__page-content *{
      display: block;
      max-width: 80%;

      @media #{$medium_mq} {
        max-width: 85%;
      }

      @media #{$large_mq} {
        max-width: 600px;
      }

      @media #{$xlarge_mq} {
        max-width: 680px;
      }
      @media #{$xlarge_mq} {
        max-width: 750px;
      }
    }
    .common-hero-label {
      @include section-title(#FFF);
      &.font-black{
        @include section-title(#343434);
      }
    }
  }

  /* barretta scroll */

  .home-scroll-invite {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    text-align: center;
    &__label {
      margin-top: 30px;
      display: inline-block;
      color: #FFF;
      font-size: 14px;
    }
    opacity: 1;
    transition: opacity 0.3s;
    .has-scrolled & {
      opacity: 0;
    }

    span{
      font-size: 1rem;
      margin-bottom: 1rem;
      display: inline-block;
      color: #FFF;
      text-transform: uppercase;
      font-weight: 700;
      cursor: pointer;
    }
  }

  .v-line {
    z-index: 20;
    position: relative;
    width: 2px;
    height: 40px;
    margin-left: auto;
    margin-right: auto;

    @media #{$medium_mq} {
      height: 50px;
    }
  }

  .v-line::after,
  .v-line::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #30AE8D;
  }

  .v-line::before {
    z-index: 20;
  }

  .v-line::after {
    z-index: 21;
    transform: scale(1, 0) translate3d(0, 0, 0);
    background: #FFF;

    animation: vert_line 6s infinite;
  }

  @keyframes vert_line {
    0% {
      transform-origin: top left;
      transform: scale(1, 0);
      animation-timing-function: cubic-bezier(0.48, 0.02, 0, 0.99);
    }

    30% {
      transform-origin: top left;
      transform: scale(1, 1);
    }

    40% {
      transform-origin: bottom left;
      transform: scale(1, 1);
      animation-timing-function: cubic-bezier(0.48, 0.02, 0, 0.99);
    }

    70% {
      transform-origin: bottom left;
      transform: scale(1, 0);
    }

    100% {
      transform-origin: bottom left;
      transform: scale(1, 0);
    }
  }

  .no-scroll-down.common-hero .home-scroll-invite{
    display: none;
  }

  .common-hero{
    min-height: auto;
    background-color: #EFEFEC;
    &.--vh100{
      min-height: 100vh;
    }
    .common-hero-container{
      padding-top: 3rem;
      padding-bottom: 3rem;
      @media #{$medium_mq} {
        padding-bottom: 4.5rem;
      }
      @media #{$large_mq} {
        padding-bottom: 6rem;
      }
      padding-top: 120px;
    }
    .common-hero__background-image{
      width: 100%; height: auto;
      position: absolute; left: 0; top: 0;
    }

    .common-hero__processing-order{
      margin: 8rem 0 3rem;

      @media #{$large_mq} {
        margin: 9rem 0 3rem;
      }

      @media #{$xlarge_mq} {
        margin: 10rem 0 3.5rem;
      }
      @media #{$xlarge_mq} {
        margin: 12rem 0 4rem;
      }
      display: block;

      font-size: .875rem;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .05rem;
      color: #FFF;
    }
  }

</style>
